import styled from 'styled-components';

export const Manufacturer = styled.div`
  background: white;
  min-height: 100%;
`
